import { render, staticRenderFns } from "./noAsignados.vue?vue&type=template&id=bcf09758&scoped=true"
import script from "./noAsignados.vue?vue&type=script&lang=js"
export * from "./noAsignados.vue?vue&type=script&lang=js"
import style0 from "./noAsignados.vue?vue&type=style&index=0&id=bcf09758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf09758",
  null
  
)

export default component.exports